import jsPDF from 'jspdf';
import moment from 'moment';
import { drawCabeceraFiscalEmpresa } from './empresa_pdf';

/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */


export default {
  methods: {
    exportFacturaExportacionPDF (venta, renglones, empresa) {
      let pdfName = 'factura_'; 
      pdfName = pdfName.concat(venta.numero.toString().trim()); 
      /* Parametros: portrait, milimetros, A4 */
      var doc = new jsPDF('p', 'mm', 'a4');

      doc.setProperties({
        title: 'Factura',
        subject: 'Factura',		
        author: 'Cervertti - Marketing & Eventos',
        creator: 'Cervetti'
      });

      // let fontName = 'CenturyGothic';
      // let fontBoldName = 'CenturyGothicBold';
      // let fontItalicName = 'CenturyGothicItalic';
      // let fontBoldItalicName = 'CenturyGothicBoldItalic';

      let fontName = 'Montserrat-Regular';
      let fontBoldName = 'Montserrat-Bold';
      let fontItalicName = 'Montserrat-Italic';
      let fontBoldItalicName = 'Montserrat-BoldItalic';

      // venta.cuit = this.$options.filters.cuit(venta.cuit);
      venta.documentoNumero = this.$options.filters.cuit(venta.documentoNumero);

      /* Limite para el salto de página */
      let positionMaxY = 240;
      /* Limite para incluir totales y datos de facturacion */
      let positionTotalesY = 250;

      /* Interlineado */
      let interlineadoRenglones = 5;
      let interlineadoTotales = 5;

      /* Formato para alinear numeros a la derecha */
      let alignRight = {
        'align': 'right'
      }

      let positionY = drawCabecera(doc, empresa, venta, 
        fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      positionY += 5;
  
      if (renglones) {
        /* Titulo de los renglones */
        // doc.setTextColor(151, 148, 149);
        doc.setTextColor(60, 60, 60);
        doc.setFont(fontBoldName, 'bold');
        // doc.setFontType('normal');

        doc.text('Servicio', 10, positionY);
        doc.text('Importe', 200, positionY, alignRight);

        for(let key in renglones) {
          const renglon = renglones[key];

          /* Verificamos si necesitamos agregar una nueva pagina */
          if (positionY + interlineadoRenglones > positionMaxY) {
            /* Agregamos una nueva pagina */
            doc.addPage();
            positionY = drawCabecera(doc, empresa, venta, 
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
          }

          positionY += interlineadoRenglones;

          doc.setFontSize(7);
          doc.setFont(fontName, 'normal');
          // doc.setFontType('normal');

          doc.text(renglon.descripcion, 10, positionY);

          if (renglon.importe != 0) {
            doc.text(this.$options.filters.numero(renglon.importe, 2), 200, positionY, alignRight);
          }
        }
      }

      /* Totales  */
      positionY = positionTotalesY;

      // positionY += 2;
      doc.line(10, positionY, 200, positionY);      

      doc.setFont(fontName, 'normal');
      doc.setFontSize(7);
      // doc.setFontType('normal');

      positionY += interlineadoTotales;
      let positionLeyendaY = positionY;

      doc.text(`Tipo de Cambio: ${this.$options.filters.numero(venta.cotizacion, 4)}`, 10, positionY);
      doc.setFont(fontBoldName, 'bold');
      // doc.setFontType('normal');
      doc.text(`Importe Total: ${this.$options.filters.moneda(venta.total, venta.moneda.trim())}`, 200, positionY, alignRight);

      drawFooter(doc, empresa, venta, fontName, fontBoldName, fontItalicName, fontBoldItalicName, positionLeyendaY);

      window.open(doc.output("bloburl", { filename: 'venta.pdf' } ));

      return;
    },
  }
}

function drawCabecera(doc, empresa, venta, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName) {
  let alignRight = {
    'align': 'right'
  }

  /* Verificamos si tiene logo asociado */
  let logoAsociado = (empresa.logoWeConnect.trim() != '')? true : false;

  drawCabeceraFiscalEmpresa({
    doc, 
    empresa, 
    fontName, 
    dark: false,
    logoAsociado
  });

  /* Tipo de comprobante */ 
  doc.setTextColor(151, 148, 149);
  doc.rect(98, 8, 14, 14);

  doc.setFont(fontBoldName, 'bold');
  // doc.setFontType('normal');
  doc.setFontSize(24);
  doc.text(venta.formulario, 102, 16.5);

  doc.setFont(fontName, 'normal');
  // doc.setFontType('normal');
  doc.setFontSize(7);
  let cadena = new String().concat('COD.', venta.afipComprobante.toString().padStart(3, '0'));
  doc.text(cadena, 100, 20);

  doc.setFontSize(10);
  // doc.setTextColor(232, 67, 113);
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);

  let positionY = 18;
  if ((/true/i).test(logoAsociado)) {
    positionY = 40;
  }

  let ventaNumeroPuntoVenta = "0000" + venta.numeroPuntoVenta;
  ventaNumeroPuntoVenta = ventaNumeroPuntoVenta.substr(ventaNumeroPuntoVenta.length - 4);
  let ventaNumero = "0000000" + venta.numero;
  ventaNumero = ventaNumero.substr(ventaNumero.length - 8);
  
  doc.text(`${venta.comprobanteTipo.trim()} ${ventaNumeroPuntoVenta}-${ventaNumero}`, 200, positionY, alignRight);
  // doc.text(`${venta.comprobanteTipo.trim()} ${venta.formulario.trim()} ${ventaNumeroPuntoVenta}-${ventaNumero}`, 205, positionY, alignRight);
  doc.setTextColor(0, 0, 0);
  positionY += 5;
  doc.text(`Fecha: ${moment(venta.fechaComprobante).format('DD/MM/YYYY')}`, 200, positionY, alignRight);

  doc.setFontSize(8);

  /* Leyenda - Exportación */
  positionY = 57;
  if ((/true/i).test(logoAsociado)) {
    positionY = 62;
  }

  doc.text('IVA EXENTO - OPERACIÓN DE EXPORTACIÓN', 71, positionY);

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  positionY += 4;
  doc.line(10, positionY, 200, positionY);

  /* Datos del cliente */
  doc.setTextColor(60, 60, 60);

  positionY = 65;
  if ((/true/i).test(logoAsociado)) {
    positionY = 70;
  }
  doc.text(`Cliente: ${venta.razonSocial.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Domicilio: ${venta.direccion.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`CUIT País: ${venta.afipCuitPais.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`ID Impositivo: ${venta.documentoNumero.trim()}`, 10, positionY);
  positionY += 6;
  doc.text(`Divisa: ${venta.monedaDescripcion.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Destino del comprobante: ${venta.pais.trim()}`, 10, positionY);

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  positionY += 4;
  doc.line(10, positionY, 200, positionY);

  return positionY;
}

function drawFooter(doc, empresa, venta, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName, positionLeyendaY) {

  let alignRight = {
    'align': 'right'
  }

  /* Interlineado */
  let interlineado = 3;

  doc.setFont(fontName, 'normal');
  // doc.setFontType('normal');

  if (venta.codigoCAE) {
    if (venta.codigoCAE.trim() != '') {

      let cuit = empresa.documentoNumero.trim().replaceAll('-', '');
      // let cuit = empresa.cuit.trim().replaceAll('-', '');
      let nroDocRec = venta.documentoNumero.trim().replaceAll('-', '');

      let json = `{"ver":1,"fecha":"${moment(venta.fechaComprobante).format('YYYY-MM-DD')}","cuit":${cuit},"ptoVta":${venta.numeroPuntoVenta.toString().trim()},"tipoCmp":${venta.afipComprobante.toString().trim()},"nroCmp":${venta.numero.toString()},"importe":${venta.montoTotal * 100},"moneda":"PES","ctz":1,"tipoDocRec":80,"nroDocRec":${nroDocRec},"tipoCodAut":"E","codAut":${venta.cae.trim()}}`;

      let url = `https://www.afip.gob.ar/fe/qr/?p=${btoa(json)}`;

      let positionY = 265;

      var qr = new VanillaQR({
        // url
        url: url,
        // width/height in pixels
        width: 400,
        height: 400,
        // colors
        colorLight: "#FFFFFF",
        colorDark: "#000000",
        // output as table or canvas
        toTable: false,
        // Ecc correction level 1-4
        ecclevel: 1,
        // Use a border or not
        noBorder: false,
        // Border size to output at
        borderSize: 2
      });

      var qrImage = qr.toImage("png");
      doc.addImage(qrImage.src, 'png', 10, positionY, 35, 35, undefined, 'FAST');

      // /* Logo AFIP */
      // doc.addImage(getBase64LogoAfip(), 'PNG', 45, positionY + 5, 18, 6);

      /* Datos de CAE */
      doc.setFont(fontName, 'normal');
      doc.setFontSize(7);
      // doc.setFontType('normal');

      positionY += 10;
      doc.text(`CAE Nº: ${venta.cae}`, 200, positionY, alignRight);
      positionY += 5;
      doc.text(`Fecha de Vto. CAE: ${moment(venta.fechaVencimientoCAE).format('DD/MM/YYYY')}`, 200, positionY, alignRight);
    }
  } 
}

